import { defineModule, VENDOR_ORDER_DOCUMENTS } from "@motolynk/app-core";

import { AdminInvoices } from "./admin/AdminInvoices";
import { VendorInvoices } from "./vendor/VendorInvoices";

import en from "./i18n/en.json";

/**
 * GST invoices (P7-04, optional): "Download invoice" on each vendor order of the admin and vendor order pages
 * (slot `orders.vendor_order.documents`). The customer's downloads are on the storefront's order page.
 */
export const invoicesModule = defineModule({
  name: "invoices",
  label: "GST invoices",
  requires: [
    "core",
    "geo",
    "accounts",
    "configuration",
    "audit",
    "notifications",
    "vehicles",
    "taxes",
    "catalog",
    "vendors",
    "products",
    "logistics",
    "cart",
    "payments",
    "payouts",
    "orders",
  ],
  i18n: { en },
  admin: {
    slots: {
      [VENDOR_ORDER_DOCUMENTS]: [
        { id: "invoices", permission: "invoices.view_taxinvoice", component: AdminInvoices },
      ],
    },
  },
  vendor: {
    slots: {
      [VENDOR_ORDER_DOCUMENTS]: [
        { id: "invoices", permission: "orders.manage", component: VendorInvoices },
      ],
    },
  },
});
